var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container py-4"},[_c('p',{staticClass:"body-2-2 mb-0 text-center"},[_vm._v("\n    Copyright © "+_vm._s(_vm.today.getFullYear())+" "+_vm._s(_vm.getMerchant.name)+" All Right Reserved\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-053bdc10","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ticket/CustomFooter.vue
// module id = null
// module chunks = 